import React from "react";
import { Container, Typography, Divider } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function AcademyGuide() {
    const { t } = useTranslation();
    return (
        <Container maxWidth="md" sx={{ mt: '50px', py: 4 }}>
            <Typography variant="h3" gutterBottom>
                {t('Footer.AcademyGuide')}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                {t('Guides.AcademyGoal')}
            </Typography>

            <Typography paragraph>
                {t('Guides.AcademyDetailsLater')}
            </Typography>

            <Typography paragraph>
                {t('Guides.ContentLater')}
            </Typography>
        </Container>
    );
}
